import { ButtonParticipant } from '@/components/ButtonParticipant'

interface ButtonParticipantMicrophoneProps {
  audioMuted: boolean
  isMicrophoneButtonVisible: boolean
  isMicrophoneEnabled: boolean
  onToggleMute: () => void
  participantName: string
}

export const ButtonParticipantMicrophone = ({
  audioMuted,
  isMicrophoneButtonVisible,
  isMicrophoneEnabled,
  onToggleMute,
  participantName,
}: ButtonParticipantMicrophoneProps) => {
  return (
    <ButtonParticipant
      isActive={!audioMuted}
      disabled={!isMicrophoneEnabled}
      isVisible={isMicrophoneButtonVisible}
      onClick={onToggleMute}
      tag={audioMuted ? 'volume-off' : 'volume-up'}
    >
      <span className="sr-only">
        {audioMuted ? 'Unmute' : 'Mute'} Microphone for {participantName}
      </span>
    </ButtonParticipant>
  )
}
